import { Image } from '@chakra-ui/react';

const LogoImage = ({ _objectFit, _maxWidth, _maxHeight, ...props }) => {
  return (
    <Image objectFit="contain" maxWidth="100%" maxHeight="100%" {...props} />
  );
};
export default LogoImage;
